<template>
  <v-layout
    column
    fill-height
    justify-space-between
  >
    <horse-table
      :headers="headers"
      :filters="filters"
    />
    <v-btn
      style="width: fit-content; align-self: flex-end"
      color="primary"
      class="mr-5 mb-5"
      depressed
      @click="openCreateHorsePage()"
    >
      {{ $route.name }} {{ $t('stallion.add') }}
      <v-icon right>
        mdi-plus
      </v-icon>
    </v-btn>
  </v-layout>
</template>
<script>
import horseTable from '@/components/horse/Table';
import { displayLocation } from '@/Helpers/location.helper';
import { locationAPI } from '@/services';
import i18n from '@/translations/i18n';

export default {
  components: { horseTable },
  data: () => ({
    locations: [],
    headers: [
      { text: i18n.t('stallion.name'), value: 'name', selected: true, groupable: false },
      { text: i18n.t('stallion.type'), value: 'type', sortable: false, selected: false },
      { text: i18n.t('stallion.nr'), value: 'surrogate_uid', selected: true, groupable: false },
      { text: i18n.t('stallion.chip'), value: 'microchip', selected: false, groupable: false },
      { text: i18n.t('stallion.location'), value: 'location', selected: true },
      { text: i18n.t('stallion.owner'), value: 'owner', selected: true },
      { text: i18n.t('stallion.surrogate'), align: 'end', value: 'surrogate', selected: true, groupable: false },
      { text: i18n.t('stallion.made'), align: 'end', value: 'createdAt', selected: false, groupable: false },
      { text: i18n.t('stallion.edit'), align: 'end', value: 'updatedAt', selected: false, groupable: false },
      { text: i18n.t('stallion.birth'), align: 'end', value: 'date_of_birth', selected: false, groupable: false },
    ],
  }),
  computed: {
    filters() {
      return {
        owner: { vTag: 'searchCustomer' },
        location: {
          vTag: 'select',
          label: i18n.t('stallion.filter'),
          items: this.locations,
          objectItems: {
            text: (item) => displayLocation(item),
            value: '_id',
          },
          options: {
            multiple: true,
          },
        },
        stud_horse: { vTag: 'switch', label: i18n.t('stallion.show') },
        aliveOnly: { vTag: 'switch', label: i18n.t('stallion.hide') },
      };
    },
  },
  mounted() { this.getLocations(); },
  methods: {
    openCreateHorsePage() {
      this.$router.push({ path: '/horse/create' });
    },
    async getLocations() {
      try {
        const { data: { locations } } = await locationAPI.getLocations();
        this.locations = locations;
      } catch (err) {
        await this.$store.dispatch('errorMessage/setError', { message: err.message, code: err.statusCode });
      }
    },
  },
};
</script>
